
class ApplicationApi {
    getApplicationList() {
        var url = apiUrl + 'applicationForms';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getListByFilter(start, end) {
        var url = apiUrl + 'applicationForms/ByFilter/';
        return api.call('get', url +  start + "/" + end)
            .then(({ data }) => {
                return data
            });
    }
 
    getApplication(id) {
        var url = apiUrl + 'applicationForms/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }
 
    createApplication(data) {
        var url = apiUrl + 'applicationForms';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }

    updateRemoveDocument(applicationFormId, documentId){
        var url = apiUrl + 'applicationForms/RemoveDocument/' + applicationFormId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    updateAddRemarks(data) {
        var url = apiUrl + 'applicationForms/AddRemarks/';
        return api.call('put', url + data.applicationFormId, data)
            .then(({ data }) => {
                return data
            });
    }
    
    
    updateOfficialOrderNo(data) {
        var url = apiUrl + 'applicationForms/UpdateOfficialOrderNo/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    updatePaymentStatus(data) {
        var url = apiUrl + 'applicationForms/UpdatePaymentStatus/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    
    
    updateInternalStatus(data) {
        var url = apiUrl + 'applicationForms/UpdateInternalStatus/';
        return api.call('put', url + data.applicationFormId, data)
            .then(({ data }) => {
                return data
            });
    }
    updateProviderStatus(data) {
        var url = apiUrl + 'applicationForms/UpdateProviderStatus/';
        return api.call('put', url + data.applicationFormId, data)
            .then(({ data }) => {
                return data
            });
    }

    updateApplication(data) {
        var url = apiUrl + 'applicationForms/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    deleteApplication(id) {
        var url = apiUrl + 'applicationForms/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

}

export default ApplicationApi;